import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { STRINGS } from "@/i18n/strings";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("nxt_lang") || "en");

  useEffect(() => { document.documentElement.lang = lang === "hi" ? "hi-Latn" : "en"; }, [lang]);

  const setLang = useCallback((l) => { localStorage.setItem("nxt_lang", l); setLangState(l); }, []);
  const toggle = useCallback(() => setLang(lang === "en" ? "hi" : "en"), [lang, setLang]);

  const t = useCallback((key, vars) => {
    let s = STRINGS[lang]?.[key] ?? STRINGS.en[key] ?? key;
    if (vars) Object.entries(vars).forEach(([k, v]) => { s = s.replace(`{${k}}`, v); });
    return s;
  }, [lang]);

  return <LangContext.Provider value={{ lang, setLang, toggle, t, isHinglish: lang === "hi" }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
